import React from "react";

/**
 * MDParticle — Maison Dodji Separator
 * ------------------------------------------------------------------
 * Marqueur graphique discret de la Maison. À utiliser uniquement
 * comme signe de respiration ou de séparation à côté d'un libellé,
 * d'un lien externe ou d'un intertitre. Ne pas multiplier, ne pas
 * animer, ne pas colorier différemment selon la page.
 *
 * Règles figées (D.A. Maison Dodji — Février 2026) :
 *   - Forme     : chevron nord-est « ↗ » (Unicode U+2197)
 *   - Taille    : 0.9em (hérite de la taille de texte parente)
 *   - Couleur   : hsl(var(--md-stone))  — jamais autre teinte
 *   - Opacité   : 1  (le token stone porte déjà la retenue)
 *   - Espacement: 0.4em gauche (via gap parent ou marge inline)
 *   - Animation : aucune
 *   - Mobile    : identique desktop (taille relative à l'em courant)
 *
 * Usage type :
 *   <a className="inline-flex items-center gap-2">
 *     Télécharger la fiche  <MDParticle />
 *   </a>
 */
export const MDParticle = ({ className = "", "aria-hidden": ariaHidden = true, ...rest }) => (
  <span
    aria-hidden={ariaHidden}
    data-testid="md-particle"
    className={`md-particle inline-block text-[hsl(var(--md-stone))] text-[0.9em] leading-none select-none ${className}`}
    {...rest}
  >
    ↗
  </span>
);

export default MDParticle;
